const Joi = require("joi");

const changePasswordSchema = (data) => {
  const schema = Joi.object({
    CurrentPassword: Joi.string()
      .trim()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      //.pattern(new RegExp("^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$"))
      // .pattern(new RegExp("^[A-Za-z\\d~!@#$%^&*()_+{}|:\"<>?\\[\\]\\\\\\-=\\;',./\\s]{3,}$"))
      .pattern(
        new RegExp(
          '^[A-Za-z\\d~`!@#$%^&*()_+{}|:"<>?\\[\\]\\\\\\-=\\;,./\\s]{3,}$'
        )
      ) //case-sensitive
      .required()
      .messages({
        "string.empty": "Please enter Current password.",
        "string.pattern.base":
          "Please enter your Current Password with at least 8 characters, including letters and numbers.",
      }),

    NewPassword: Joi.string()
      .min(8)
      // .pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#$%^&*()_+{}|:"<>?\[\]\\\-=;',./]).{8,}$/)
      .pattern(/^(?=.*[A-Za-z])(?=.*\d).{8,}$/) // Requires at least one letter and one number, allows special characters
      .required()
      .messages({
        "string.empty": "Please enter New Password.",
        "string.min":
          "Please enter your New Password with at least 8 characters, including letters and numbers.",
        "string.pattern.base":
          "Please enter your New Password with at least 8 characters, including letters and numbers.",
      }),

    confirmPassword: Joi.string()
      .required() // This ensures the field is not empty
      .messages({
        "string.empty": "Please enter Confirm Password.", // Triggers when the field is empty
      })
      .custom((value, helpers) => {
        // Check if confirmPassword matches NewPassword
        if (value !== helpers.state.ancestors[0].NewPassword) {
          return helpers.message(
            "Please make sure the Password and confirm password fields match."
          );
        }
        return value; // If they match, return the value
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = changePasswordSchema;
